<template>
  <pt-collapsible-sidebar
    ref="sidebarLeft"
    :overlay="true"
    :partial-collapse="false"
    class="sidebar"
  >
    <!-- <div slot="collapsed" class="h-screen text-center flex flex-col flex-1 justify-between">
      <div>
        <div class="h-16 flex justify-center items-center">
          <button class="p-2 rounded-full hover:bg-grey-light focus:outline-none" @click="toggleSidebar">
            <i class="fa fa-bars fa-lg" />
          </button>
        </div>
        <ul class="list-reset mt-5 menu-icons">
          <li class="py-2">
            <router-link :to="{ name: 'dashboard' }">
              <i class="fa fa-plus-circle fa-lg text-black p-2 rounded-full hover:bg-grey-lighter hover:text-primary" />
            </router-link>
            <router-link :to="{ name: 'profile' }">
              <i class="fa fa-plus-circle fa-lg text-black p-2 rounded-full hover:bg-grey-lighter hover:text-primary" />
            </router-link>
          </li>
        </ul>
      </div>
      <ul class="list-reset mb-5 menu-icons">
        <li class="py-2">
          <pt-popover placement="right">
            <img
              :title="userName"
              :alt="userName"
              src="img/default-user.3c1dd009.png"
              class="rounded-full cursor-pointer"
              width="30"
              height="30"
            />
            <div slot="body" class="w-32">
              <button
                class="p-2 w-full hover:bg-grey-lighter text-left text-lg"
                @click="handleLogout"
              >
                Log out
              </button>
            </div>
          </pt-popover>
        </li>
      </ul>
    </div> -->
    <div slot="expanded" class="h-screen pt-10">
      <div class="flex justify-center pb-4">
        <img :src="profileImage" class="w-10 h-10 rounded-full mr-4" />
        <h2 class="self-center">{{ userName }}</h2>
      </div>
      <nav-items />
    </div>
  </pt-collapsible-sidebar>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import NavItems from '@components/navigation/NavItems';
import config from '../../config';

export default {
  name: 'SidebarNav',
  components: {
    NavItems,
  },
  computed: {
    ...mapGetters({
      userName: 'auth/userName',
      userAvatar: 'auth/userAvatar',
    }),
    profileImage() {
      if (this.userAvatar) {
        return config.api.imageURL + this.userAvatar;
      }
      return '/img/default-user.3c1dd009.png';
    },
  },
  created() {
    this.$bus.$on('toggle-sidebar', () => {
      this.toggleSidebar();
    });
  },
  methods: {
    handleLogout() {
      this.logOut();
      this.$router.replace({ name: 'login' });
    },
    toggleSidebar() {
      if (this.$refs.sidebarLeft) {
        this.$refs.sidebarLeft.toggle();
      }
    },
    ...mapActions({
      logOut: 'auth/logOut',
    }),
  },

};
</script>

<style scoped>
.menu-labels a {
  padding: 0.9rem;
}
.menu-icons .router-link-exact-active i {
  color: #E83330;
}
.menu-labels .router-link-exact-active {
  color: #E83330;
  border-right: 4px solid #E83330;
}
</style>
